import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {CompetitionsSliderWidgetController} from "../competitions-slider-widget.controller";
import {CompetitionsDomainService} from "../../../domain/competitions/services/competitions.domain-service";
import {CompetitionsRequestParams} from "../../../domain/competitions/models/competitions.request-params";
import {COMPETITIONS_SLIDER_WIDGET} from "../competition-slider-widget.consts";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {COMPONENT_STATES} from "../../../core/consts";

export class CompetitionsSliderWidgetFetchHandler extends FetchHandler {
  controller: CompetitionsSliderWidgetController;

  static injectables = [CompetitionsDomainService];

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): BaseApiRequestParams {
    const competitionsIds: Array<Number> = this.controller.props.competitionIds;
    const requestParams: CompetitionsRequestParams = new CompetitionsRequestParams(null, competitionsIds);

    return requestParams;
  }

  async action() {
    const hasPublisher = this.appStore.state.settings.publisherSettings?.id > 0;
    const shouldFetch = this.controller.props.competitionIds?.length > 0 || hasPublisher;
    let dataSource = null;

    if(shouldFetch) {
      dataSource = shouldFetch ? await super.fetch() : null;
      await this.controller.action(COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.populateCompetitionsDataHandler, {dataSource});
      await this.controller.action(COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.fetchGames);

      this.controller.action(COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.displayEvent);
    }

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return dataSource;
  }
}
